import { render, staticRenderFns } from "./AppHeaderSpMenu.vue?vue&type=template&id=64b05b74&scoped=true"
import script from "./AppHeaderSpMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppHeaderSpMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppHeaderSpMenu.vue?vue&type=style&index=0&id=64b05b74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b05b74",
  null
  
)

export default component.exports